<template>
  <div class="ts-p-3">
    <div class="ts-overflow-y-scroll max-h">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-text-center" style="width: 2%">
              {{ $t('no') }}
            </th>
            <th style="width: 11%">
              {{ $t('purchaseRequest.productGroup') }}
            </th>
            <th style="width: 11%">
              {{ $t('purchaseRequest.barcode') }}
            </th>
            <th style="width: 15%">
              {{ $t('purchaseRequest.productName') }}
            </th>
            <th class="ts-text-center" style="width: 6%">
              {{ $t('purchaseRequest.uom') }}
            </th>
            <th class="ts-text-center" style="width: 7%">
              {{ $t('purchaseRequest.quantity') }}
            </th>
            <th class="ts-text-right" style="width: 8%">
              {{ $t('purchaseRequest.unitPrice') }}
            </th>
            <th class="ts-text-right" style="width: 8%">
              {{ $t('purchaseRequest.total') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.maxReorder') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('purchaseRequest.alloworder') }}
            </th>
            <th>
              {{ $t('purchaseRequest.remarks') }}
            </th>

          </tr>
        </thead>
        <tbody>
          <tr v-if="!edit_data.details">
            <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
            </td>
          </tr>
          <tr v-for="(d, index) in edit_data.details" :key="index">
            <td class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td>
              {{ d.product ? d.product.pro_group_name_en : '' }}
            </td>
            <td>
              {{ d.product ? d.product.barcode : '' }}
            </td>
            <td>
              {{ d.product ? d.product.product_name_en : '' }}
            </td>
            <td class="ts-text-center">
              {{ d.unite_of_measure ? d.unite_of_measure.uom_name_en : '' }}
            </td>
            <td class="ts-text-center">
              {{ d.quantity }}
            </td>
            <td class="ts-text-right">
              <ts-display-currency :amount="d.input_unit_price" :currency_id="d.currency_id" />
            </td>
            <td class="ts-text-right">
              <ts-display-currency :amount="d.input_total" :currency_id="d.currency_id" />
            </td>
            <td class="ts-text-center">
              {{ d.product.maximum_reorder_allow ? d.product.maximum_reorder_allow : 'N/A' }}
            </td>
            <td style="width: 1%" class="ts-text-center">
              <span class="badge badge-success" v-if="allowOrder(d)">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ d.remarks }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-footer">
            <td colspan="4">
              <b>
                {{ $t('purchaseRequest.numberRow') }} :
                {{ edit_data.details ? edit_data.details.length : 0 }}
              </b>
            </td>
            <td class="ts-text-right">
              <b>{{ $t('purchaseRequest.total') }} :</b>
            </td>
            <td class="ts-text-center">
              <b>{{ sumTotalQty }}</b>
            </td>
            <td></td>
            <td>
              <ts-display-currency :amount="sumTotal" :currency_id="defaultCurrency.currency_id" />
            </td>
            <td colspan="3"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sumBy } from 'lodash'

export default {
  name: 'purchaseRequestItem',
  props: ['value', 'validate'],
  data() {
    return {
      model: {}
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['edit_data', 'formViewDatas']),
    defaultCurrency() {
      if (this.$store.state.exchangeRate.currency.formViewDatas['default']) {
        return this.$store.state.exchangeRate.currency.formViewDatas['default']
      }
      return {
        currency_symbol: '$',
        currency_rounding: 2
      }
    },
    sumTotalQty() {
      return sumBy(this.edit_data.details, 'quantity')
    },
    sumTotal() {
      return sumBy(this.edit_data.details, 'total')
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    allowOrder(row) {
      return row.quantity >
        (row.product.maximum_reorder_allow
          ? row.product.maximum_reorder_allow
          : 0)
    },
  },
  watch: {}
}
</script>

<style scoped>
.max-h {
  min-height: 30vh;
  max-height: 50vh;
}

table {
  position: relative;
  border-collapse: collapse;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
  text-transform: uppercase;
  border-width: 1px;
  white-space: nowrap;
}

table tbody tr td {
  padding: 4px 5px;
  border-width: 1px;
}

table tfoot tr {
  background-color: #e3e8f1;
  border-width: 1px;
}

table tfoot tr td {
  padding: 7px 5px;
  white-space: nowrap;
  color: #c53030;
}
</style>
